import clsx from 'clsx'
import { useThemeStore, ThemeMode } from '../../store/themeStore'
import { Sym } from './Sym'

const OPTIONS: { mode: ThemeMode; icon: string; label: string }[] = [
  { mode: 'light', icon: 'light_mode', label: 'Light' },
  { mode: 'dark', icon: 'dark_mode', label: 'Dark' },
  { mode: 'system', icon: 'computer', label: 'Follow system' },
]

/** Segmented Light / Dark / System theme switch for the app header. */
export default function ThemeToggle() {
  const mode = useThemeStore((s) => s.mode)
  const setMode = useThemeStore((s) => s.setMode)
  return (
    <div
      className="inline-flex items-center gap-0.5 rounded-lg border border-border bg-background p-0.5"
      role="group"
      aria-label="Theme"
    >
      {OPTIONS.map((o) => (
        <button
          key={o.mode}
          type="button"
          onClick={() => setMode(o.mode)}
          title={o.label}
          aria-label={o.label}
          aria-pressed={mode === o.mode}
          className={clsx(
            'grid h-7 w-7 place-items-center rounded-md transition-colors',
            mode === o.mode
              ? 'bg-primary/15 text-primary-400'
              : 'text-text-muted hover:text-text-primary'
          )}
        >
          <Sym name={o.icon} size={17} />
        </button>
      ))}
    </div>
  )
}
